import { SingletonInstanceId } from '../../constants/services.esm.js';
import { LayoutType } from '../../types/layouts.esm.js';

function layoutToEntityValue(layout) {
  switch (layout.type) {
    case LayoutType.Default:
      {
        throw new Error('Default layout is never saved in the database');
      }
    case LayoutType.Custom:
      {
        var _layout$fields;
        if (!layout.selected) {
          throw new Error('We only save the custom layout in the database if it is the current/instance');
        }
        var layoutId = SingletonInstanceId;
        var type = LayoutType.Custom;
        var columns = (_layout$fields = layout.fields) === null || _layout$fields === void 0 ? void 0 : _layout$fields.filter(function (c) {
          return c !== null && c !== undefined;
        });
        return {
          layoutId: layoutId,
          type: type,
          columns: columns
        };
      }
    case LayoutType.Predefined:
      {
        if (!layout.selected) {
          throw new Error('We only save the predefined layout in the database if it is the current/instance');
        }
        var _layoutId = layout.id;
        var _type = LayoutType.Custom;
        var name = layout.label;
        if (!(name !== null && name !== void 0 && name.length)) {
          throw new Error('Missing Name');
        }
        if (!(_layoutId !== null && _layoutId !== void 0 && _layoutId.length)) {
          throw new Error('Missing id');
        }
        return {
          layoutId: _layoutId,
          type: _type,
          name: name
        };
      }
    case LayoutType.Saved:
      {
        var _layout$fields2;
        var _layoutId2 = layout.id;
        var _type2 = LayoutType.Saved;
        var _name = layout.label;
        var _columns = (_layout$fields2 = layout.fields) === null || _layout$fields2 === void 0 ? void 0 : _layout$fields2.filter(function (c) {
          return c !== null && c !== undefined;
        });
        if (!(_name !== null && _name !== void 0 && _name.length)) {
          throw new Error('Missing Name');
        }
        if (!(_layoutId2 !== null && _layoutId2 !== void 0 && _layoutId2.length)) {
          throw new Error('Missing id');
        }
        return {
          layoutId: _layoutId2,
          type: _type2,
          name: _name,
          columns: _columns
        };
      }
    default:
      {
        throw new Error("Invalid layout type");
      }
  }
}

export { layoutToEntityValue };
//# sourceMappingURL=layout-to-entity.esm.js.map
